/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { candidateEmailAttachmentDataScanStatusSchema } from './CandidateEmailAttachmentDataScanStatusSchema'

export const candidateEmailAttachmentDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	size: z.number(),
	type: z.string().nullable(),
	url: z.string().nullable(),
	scanStatus: candidateEmailAttachmentDataScanStatusSchema.nullable(),
	scanSignature: z.string().nullable(),
})

export type CandidateEmailAttachmentDataSchema = z.infer<typeof candidateEmailAttachmentDataSchema>
